export const queryByParams = (key: string, value: string): string => {
  return `*[${key} == "${value}"]`;
};